exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".video-wrap[data-v-a1785d86]{position:relative;height:450px}", ""]);

// exports
